import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TableConfig } from "@app/shared/util/table-config.utils";
import { ToolReturn } from "@models/tool-return.model";

@Component({
    selector: 'app-pending-tool-returns-table',
    templateUrl: './pending-tool-returns-table.component.html',
    styleUrls: ['./pending-tool-returns-table.component.scss']
})
export class PendingToolReturnsTableComponent {

    @Input() pendingToolReturns: ToolReturn[] = [];
    @Input() tableConfig: TableConfig;
    @Input() isLoading = false;
    @Input() statusFilters = [];
    @Input() headerBackgroundColor: string;
    @Input() hasTitle = false;
    @Input() isMaterial = false;
    @Input() showFilters = false;

    @Output() pageChange = new EventEmitter<any>();
    @Output() filterChange = new EventEmitter<any>();
    @Output() sortChange = new EventEmitter<any>();
    @Output() rowClick = new EventEmitter<any>();


    onPageChange(tableConfig: TableConfig) {
        this.pageChange.emit(tableConfig);
    }

    onSortChange(tableConfig: TableConfig) {
        this.sortChange.emit(tableConfig);
    }

    onFilterChange(tableConfig: TableConfig) {
        this.filterChange.emit(tableConfig);
    }

    onRowClick(clickedItem) {
        this.rowClick.emit(clickedItem);
    }
}
